import { render } from "./Textarea.vue?vue&type=template&id=07a71d50"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"

import "./Textarea.vue?vue&type=style&index=0&id=07a71d50&lang=scss"
script.render = render

export default script